import {
  Avatar,
  AvatarProps,
  Badge,
  Dot,
  P,
  Tooltip,
} from '@fashionnovateam/nova-ui-toolkit';
import React from 'react';
import { ChatUser, PurchaseOrderChatMessage } from './types';
import { useChatContext, useUser } from './hooks';

export function ChatUserTooltipContent(props: {
  name: string;
  chatUser: ChatUser | PurchaseOrderChatMessage['author'] | undefined;
  badgeType?: AvatarProps['badgeType'];
}) {
  const { name, chatUser, badgeType } = props;

  const roleVendor =
    (chatUser?.attributes.type === 'vp' && chatUser?.attributes.role) ||
    undefined;

  return (
    <div className="flex flex-row gap-3 py-1 items-center">
      <Avatar name={chatUser?.friendlyName || name} badgeType={badgeType} />
      <div className="flex flex-col gap-0.5">
        <div className="flex flex-row gap-2 items-center">
          <P>{chatUser?.friendlyName || name}</P>
          {roleVendor && (
            <Badge color="purple" contrast="low">
              {roleVendor === 'VENDOR' ? 'Vendor Admin' : 'Vendor Staff'}
            </Badge>
          )}
        </div>
        {chatUser && (
          <div className="flex flex-row gap-1 items-center">
            <Dot
              color={
                (
                  'instance' in chatUser
                    ? chatUser.instance.isOnline
                    : chatUser.isOnline
                )
                  ? 'green'
                  : 'yellow'
              }
            />
            <P>
              {(
                'instance' in chatUser
                  ? chatUser.instance.isOnline
                  : chatUser.isOnline
              )
                ? 'Online'
                : 'Offline'}
            </P>
          </div>
        )}
      </div>
    </div>
  );
}

export function ChatUserTooltip({
  userType,
  id,
  name,
  children,
}: {
  userType: 'vp' | 'internal';
  id: string;
  name: string;
  children: React.ReactNode;
}) {
  const { client, userId } = useChatContext();
  const userProcess = useUser(client, userId, `${userType}_${id}`);
  return (
    <Tooltip
      arrow
      color="white"
      position="top"
      content={
        <ChatUserTooltipContent
          name={name}
          chatUser={userProcess.data}
          badgeType={userType === 'vp' ? 'vendor' : 'fn_internal'}
        />
      }
    >
      {children}
    </Tooltip>
  );
}
